import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { FILTER_DATA_LIST_RESPONSE } from "../types/ResponseTypes";
import {  GET_FILTER_ANESTHESIOLOGIST_QUERY_KEY, GET_FILTER_QUERY_KEY } from "../types/CommonTypes";

type FilterContextParams = {
  startDate: string;
  endDate: string;
  ots?: string;
  procedureIds?: string;
  nurseIds?: string;
};

async function getFilterAnesthesiologistData(params: FilterContextParams): Promise<FILTER_DATA_LIST_RESPONSE> {
  const { data } = await fetcher({
    url: "analytics/filter-options/anesthesiologists",
    params,
  });
  return data?.options || [];
}

export function useGetFilterAnesthesiologistsQuery(params: FilterContextParams,enabled: boolean = false) {
  return useQuery({
    queryKey: [GET_FILTER_QUERY_KEY, GET_FILTER_ANESTHESIOLOGIST_QUERY_KEY, params],
    queryFn: () => getFilterAnesthesiologistData(params),
    enabled: enabled && !!params, 
    staleTime: 5 * 60 * 1000,
  });
}
